/**
 * @generated SignedSource<<a4e17b9b34910bdeb0580a071fec4b93>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4AppsContent_navigationCustomisation$data = {
  readonly sidebar: {
    readonly nodes: ReadonlyArray<{
      readonly menuId: string | null;
      readonly visible: boolean | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "Nav4AppsContent_navigationCustomisation";
};
export type Nav4AppsContent_navigationCustomisation$key = {
  readonly " $data"?: Nav4AppsContent_navigationCustomisation$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4AppsContent_navigationCustomisation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "Nav4AppsContent_navigationCustomisation",
  "selections": [
    {
      "concreteType": "SettingsMenuItemConnection",
      "kind": "LinkedField",
      "name": "sidebar",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsMenuItem",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "menuId"
            },
            {
              "kind": "ScalarField",
              "name": "visible"
            }
          ]
        }
      ]
    }
  ],
  "type": "SettingsNavigationCustomisation"
};

(node as any).hash = "7ec05a83945ca64d0514182d60812eca";

export default node;
